import React from 'react';
import StoreUtils from "../../../../../services/Store/StoreUtils";
import {RootState} from "../../../../../../reducers";
import {getStoreConfig} from "../../../../../services/Store/reducer";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";

interface OwnProps {
    productState: Record<string, any>;
    updateProductState: (productState: Record<string, any>) => void;
    nested?: true;
    isProductAvailable: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductComment = ({nested, config, productState, updateProductState, isProductAvailable}: Props) => {
    const {t} = useTranslation();

    if (nested || !StoreUtils.isItemCommentAvailable(config) || !isProductAvailable) return <></>;

    const handleChangeComment = (comment: string) => {
        updateProductState({
            ...productState,
            comment
        });
    };

    return (
        <div className="form-group">
            <textarea value={productState.comment}
                      onChange={(event) => handleChangeComment(event.target.value)}
                      className="form-control"
                      placeholder={t("modules.menu.field.comment.title")}/>
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ProductComment));
